/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_OverrideInputs */

const en_cp_mock_override = /** @type {(inputs: Cp_Mock_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exceptions`)
};

const id_cp_mock_override = /** @type {(inputs: Cp_Mock_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengecualian`)
};

/**
* | output |
* | --- |
* | "Exceptions" |
*
* @param {Cp_Mock_OverrideInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_override = /** @type {((inputs?: Cp_Mock_OverrideInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_OverrideInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_override(inputs)
	return en_cp_mock_override(inputs)
});